import { _ as _defineProperty } from '../unsorted/defineProperty.js';
import { useContext, useSyncExternalStore, useRef, useCallback, createContext } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createFastContext(initialState, reducer) {
  function useStoreData() {
    var store = useRef(initialState);
    var get = useCallback(function () {
      return store.current;
    }, []);
    var subscribers = useRef(new Set());
    var set = useCallback(function (value) {
      store.current = _objectSpread(_objectSpread({}, store.current), value);
      subscribers.current.forEach(function (callback) {
        return callback();
      });
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    var dispatch = useCallback(function (action) {
      if (reducer) {
        store.current = reducer(store.current, action);
        subscribers.current.forEach(function (callback) {
          return callback();
        });
      } else {
        throw new Error("Dispatching actions is only possible when a reducer is provided");
      }
    }, []);
    var subscribe = useCallback(function (callback) {
      subscribers.current.add(callback);
      return function () {
        return subscribers.current["delete"](callback);
      };
    }, []);

    // @NOTE: ensure that these useCallback functions are apprioriately named
    // inside of React Dev tools (eases debugging)
    Object.defineProperty(get, "name", {
      value: "get",
      writable: false
    });
    Object.defineProperty(set, "name", {
      value: "set",
      writable: false
    });
    Object.defineProperty(subscribe, "name", {
      value: "subscribe",
      writable: false
    });
    Object.defineProperty(dispatch, "name", {
      value: "dispatch",
      writable: false
    });
    return {
      get: get,
      set: set,
      subscribe: subscribe,
      dispatch: dispatch
    };
  }
  var StoreContext = /*#__PURE__*/createContext(null);
  function Provider(_ref) {
    var children = _ref.children;
    return jsx(StoreContext.Provider, {
      value: useStoreData(),
      children: children
    });
  }
  // @NOTE: allow the naming of this Provider in the consumer of it
  // (mostly for debugging purposes)
  Provider.displayName = "";
  function useStore(selector) {
    var store = useContext(StoreContext);
    if (!store) {
      throw new Error("Store not found");
    }
    var state = useSyncExternalStore(store.subscribe, function () {
      return selector(store.get());
    }, function () {
      return selector(initialState);
    });
    return {
      state: state,
      setState: store.set,
      dispatchAction: store.dispatch
    };
  }
  return {
    Provider: Provider,
    useStore: useStore
  };
}

export { createFastContext as c };
//# sourceMappingURL=createFastContext.js.map
